/**
 * Does this user have to set up TOTP before they can use the product?
 *
 * ONE place decides. This rule used to live in three: the login hook's
 * redirect switch, the AuthProvider's login path, and the AuthProvider's
 * session-restore path — each deriving
 * `(is_global_admin || is_company_admin) && !mfa_enabled` for itself. Fixing
 * two of them left the third redirecting, which is exactly what happened when
 * the local-dev bypass (MI_DEV_DISABLE_ADMIN_MFA) was switched on: the API
 * waved the company admin through and the client still bounced them to
 * /mfa/setup.
 *
 * The SERVER owns the answer, because only the server knows the environment.
 * `must_setup_totp` also covers WebAuthn-only users, who need a TOTP fallback
 * without being admins. The derivation survives only as a fallback for a
 * backend old enough not to send the field.
 */
export function needsTotpSetup(u: {
  is_global_admin: boolean;
  is_company_admin: boolean;
  mfa_enabled: boolean;
  // `| undefined` explicitly: the repo runs exactOptionalPropertyTypes, so an
  // optional Zod field is not assignable to a plain optional property.
  must_setup_totp?: boolean | undefined;
}): boolean {
  return (
    u.must_setup_totp ??
    ((u.is_global_admin || u.is_company_admin) && !u.mfa_enabled)
  );
}
